// Skeleton loading components for progressive data display

export function StatCardSkeleton() {
    return (
        <div className="bg-(--card-bg) rounded-xl p-6 shadow-sm border border-(--border-color) animate-pulse">
            <div className="flex items-center justify-between">
                <div className="flex-1">
                    <div className="h-4 bg-gray-200 rounded w-24 mb-3"></div>
                    <div className="h-8 bg-gray-300 rounded w-16"></div>
                </div>
                <div className="w-12 h-12 bg-gray-200 rounded-lg"></div>
            </div>
        </div>
    );
}

export function ActivityCardSkeleton() {
    return (
        <div className="p-4 rounded-lg border border-(--border-color) animate-pulse">
            <div className="flex items-start justify-between mb-3">
                <div className="flex-1">
                    <div className="h-5 bg-gray-300 rounded w-3/4 mb-2"></div>
                    <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                </div>
                <div className="h-6 w-24 bg-gray-200 rounded-full"></div>
            </div>
            <div className="flex items-center gap-4">
                <div className="flex-1 bg-gray-100 rounded-full h-2"></div>
                <div className="h-4 w-12 bg-gray-200 rounded"></div>
            </div>
        </div>
    );
}

export function ClassCardSkeleton() {
    return (
        <div className="p-5 rounded-xl border-2 border-(--border-color) animate-pulse">
            <div className="flex items-center justify-between mb-3">
                <div className="w-10 h-10 bg-gray-200 rounded-lg"></div>
                <div className="h-6 w-20 bg-gray-200 rounded-full"></div>
            </div>
            <div className="h-6 bg-gray-300 rounded w-3/4 mb-2"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
        </div>
    );
}
